export const glossary = {
  // META
  'glossary.meta.title': 'Realitní slovníček',
  'glossary.meta.description':
    'Tápete s prodejem či koupí nemovitosti? My se v realitách vyznáme',

  // TEXTS
  'glossary.header.not_found': 'Tato stranka neexistuje',
  'glossary.header.title': 'Slovníček',
  'glossary.header.subtitle':
    'Zorientovat se v realitních pojmech může být oříšek. Abychom vám ho pomohli rozlousknout,  vypracovali jsme pro vás slovníček  pojmů, na které můžete při prodeji nemovitosti narazit.',
};
